@if (measureToolsUsed) {
  <div class="map-tools">
  @if (measureToolsVisable) {
    <div id="measureButtonsContainer">
      @if (measureDistance_visable) {
        <div>
          @if (!measureToolsUnits) {
            <div>
              <button id="measureLineButton" class="measureButtons" (click)="measureClicked(MeasureUnit.Metric)" mat-raised-button
                color="primary">
                {{selText.measureLine}}
              </button>
            </div>
          }
        </div>
      }
      @if (measureDistance_visable) {
        <div>
          @if (measureToolsUnits) {
            <div>
              <button id="measureNauticalButton" class="measureButtons" (click)="measureClicked(MeasureUnit.Nautical)"
                mat-raised-button color="primary">
                {{selText.nauticalMiles}}
              </button>
            </div>
          }
        </div>
      }
      @if (measureDistance_visable) {
        <div>
          <button id="measureAngleButton" class="measureButtons" (click)="measureClicked(MeasureUnit.Angle)" mat-raised-button
            color="primary">
            {{selText.measureAngle}}
          </button>
        </div>
      }
      @if (measureAreaVisable) {
        <div>
          <button id="measurePolygonButton" class="measureButtons" (click)="measureClicked(MeasureUnit.Polygon)" mat-raised-button
            color="primary">
            {{selText.measureArea}}
          </button>
        </div>
      }
      @if (measureAreaVisable || measureDistance_visable) {
        <div>
          <button class="measureButtons" (click)="clearMeasures()" mat-raised-button color="primary">
            {{selText.clearMeasure}}
          </button>
        </div>
      }
      @if (measureAreaVisable || measureDistance_visable) {
        <div>
          <button class="measureButtons" (click)="flipVisibility()" mat-raised-button color="primary">
            {{selText.quit}}
          </button>
        </div>
      }
    </div>
  }
</div>
}
@if (sessionURL_visable) {
  <div class="sessionURL">
    <a href="{{getSessionURL()}}">{{getSessionURL()}}</a>
    <button class="closeBtn" (click) = "closeSessionURL()"><mat-icon>close</mat-icon></button>
  </div>
}
<div id="tlContainer" class='timecontainer'>
  @if ((timeLayers.length > 0 || splitTimeLayers.length > 0) && (this.displayService.isLayerTimelineVisible$ | async)) {
    <div class="timePlayer">
      <div class="layers">
        <div class="playTime">
          @if (!isMoving) {
            <button (click)="playTime()" id='pauseplay'>
              <mat-icon id="play-img">play_arrow</mat-icon>
            </button>
          }
          @if (isMoving) {
            <button (click)="playTime()" id='pauseplay'>
              <mat-icon id="play-img">pause</mat-icon>
            </button>
          }
        </div>
        <div class='dynamic-layers'>
          <button id='pauseplay' (click)="flipDynamicLayerList()">
            <mat-icon id="dynalayers">menu</mat-icon>
          </button>
        </div>
        <div class="currentTime">
          {{currentTime}}
        </div>
        <div class="framerate">
          @if (allowSpeedControl) {
            <button id="framerateButton" (click)="changeFramerate(true)">
              <img id="framerateDown" src="assets/images/play_icon.png"/>
            </button>
          }
          @if (allowSpeedControl) {
            <div id="framerateDisplay">
              {{playSpeed}}x
            </div>
          }
          @if (allowSpeedControl) {
            <button id="framerateButton" (click)="changeFramerate(false)">
              <img id="framerateUp" src="assets/images/play_icon.png"/>
            </button>
          }
        </div>
        <div class="tabs-wrapper">
          @for (x of timeLayers; track x.id) {
            <div class="tabs-container">
              <button class="time-tabs isTimeActive" (click)="turnOffLayer(x)" [innerHTML]="getDisplayTitle(x)">
              </button>
            </div>
          }
          @for (y of splitTimeLayers; track y.id) {
            <div class="tabs-container">
              <button disabled class="time-tabs isTimeActive" [innerHTML]="getDisplayTitle(y) + '(hægri)'"></button>
            </div>
          }
        </div>
      </div>
      <div class="slidecontainer">
        <div class="slider-pos">
          <input  type="range"
            min="0"
            step="any"
            [max]="timeLayerSelected?.option.times.length-1"
            [value]="selectedTimeLayerPointerFloat"
            class="slider"
            id="myRange"
            #ref
            (click)="changeVal(ref.value)"
            >
          <div class="ticker-container">
            <div class="tickers">
              <div class="ticker" id="leftTicker"></div>
              @for (x of [].constructor(currentTimesLength-3); track $index) {
                <div class="ticker"></div>
              }
              <div class="ticker" id="rightTicker"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="tl-footer-container">
        <div class="bookendTime" id="starttime">
          {{prettifyTimes(timeLayerSelected?.option.times[0])}}
        </div>
        <div>
          <button id="flip-btn" (click)="flipTimePlayer()">
            <mat-icon id="flip-icon">keyboard_double_arrow_up</mat-icon>
          </button>
        </div>
        <div class="bookendTime" id="endtime">
          {{prettifyTimes(timeLayerSelected?.option.times[timeLayerSelected?.option.times.length-1])}}
        </div>
      </div>
    </div>
  }
  @if (timeLayers.length > 0 && (this.displayService.isLayerTimelineVisible$ | async) === false) {
    <div class="timePlayer-closed">
      <div>
        <button id="flip-btn" (click)="flipTimePlayer()">
          <mat-icon id="flip-icon">keyboard_double_arrow_down</mat-icon>
        </button>
      </div>
    </div>
  }
  @if (showDynamicLayerList && (this.displayService.isLayerTimelineVisible$ | async) && timeLayers.length > 0) {
    <div class="dynamiclayers-list">
      @for (x of [].constructor(timeLayerSelected?.option.times.length); track $index) {
        <div class='dynamiclayers-list-entry'
          >
          <button (click)='changeVal($index)'
            id='timeentry-btn'>{{prettifyTimes(timeLayerSelected?.option.times[$index])}}</button>
        </div>
      }
    </div>
  }
</div>